// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#1482FF","secondColor":"#3f4956","activeColor":"#f4657d","blueColor":"#FFAE2D","cancelColor":"#c8c9cc","statusColor":"#ED4133"};